import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, setToken, getUser } from '../services/api';
import './Login.css';

export default function Login() {
  const navigate = useNavigate();
  const [mode, setMode]       = useState('login'); // login | forgot | reset
  const [email, setEmail]     = useState('');
  const [password, setPassword] = useState('');
  const [otp, setOtp]         = useState('');
  const [newPass, setNewPass] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');
  const [msg, setMsg]         = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const data = await api.login(email, password);
      setToken(data.token);
      const user = getUser();
      if (user.role === 'User') {
        navigate('/employee');
      } else {
        const hasOnboarded = localStorage.getItem('ryzenos_onboarded');
        if (!hasOnboarded && user.role === 'Super Admin') {
          localStorage.setItem('ryzenos_onboarded', '1');
          navigate('/onboarding');
        } else {
          navigate('/dashboard');
        }
      }
    } catch (err) {
      setError(err.message);
    } finally { setLoading(false); }
  };

  const handleForgot = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await api.forgotPassword(email);
      setMsg('OTP sent to your email. Check inbox.');
      setMode('reset');
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  const handleReset = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      await api.resetPassword(email, otp, newPass);
      setMsg('Password reset! Please login.');
      setMode('login');
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="login-wrap">
      <div className="login-card">
        <div className="login-logo">R</div>
        <div className="login-brand">RyzenOS</div>
        <div className="login-sub">
          {mode === 'login'  && 'Sign in to your workspace'}
          {mode === 'forgot' && 'Reset your password'}
          {mode === 'reset'  && 'Enter OTP and new password'}
        </div>

        {error && <div className="login-err">{error}</div>}
        {msg   && <div className="login-msg">{msg}</div>}

        {mode === 'login' && (
          <form onSubmit={handleLogin} className="login-form">
            <div className="login-grp">
              <label className="login-lbl">Email</label>
              <input className="login-inp" type="email" placeholder="you@company.com"
                value={email} onChange={e => setEmail(e.target.value)} required autoFocus/>
            </div>
            <div className="login-grp">
              <label className="login-lbl">Password</label>
              <input className="login-inp" type="password" placeholder="••••••••"
                value={password} onChange={e => setPassword(e.target.value)} required/>
            </div>
            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
            <div className="login-forgot" onClick={() => { setMode('forgot'); setError(''); setMsg(''); }}>
              Forgot password?
            </div>
          </form>
        )}

        {mode === 'forgot' && (
          <form onSubmit={handleForgot} className="login-form">
            <div className="login-grp">
              <label className="login-lbl">Email</label>
              <input className="login-inp" type="email" placeholder="you@company.com"
                value={email} onChange={e => setEmail(e.target.value)} required autoFocus/>
            </div>
            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? 'Sending…' : 'Send OTP'}
            </button>
            <div className="login-forgot" onClick={() => { setMode('login'); setError(''); setMsg(''); }}>
              Back to login
            </div>
          </form>
        )}

        {mode === 'reset' && (
          <form onSubmit={handleReset} className="login-form">
            <div className="login-grp">
              <label className="login-lbl">OTP (check your email)</label>
              <input className="login-inp" placeholder="6-digit code"
                value={otp} onChange={e => setOtp(e.target.value)} required autoFocus maxLength={6}/>
            </div>
            <div className="login-grp">
              <label className="login-lbl">New password</label>
              <input className="login-inp" type="password" placeholder="Min 8 characters"
                value={newPass} onChange={e => setNewPass(e.target.value)} required minLength={8}/>
            </div>
            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? 'Resetting…' : 'Reset password'}
            </button>
            <div className="login-forgot" onClick={() => { setMode('login'); setError(''); setMsg(''); }}>
              Back to login
            </div>
          </form>
        )}

        <div className="login-footer">
          Powered by Ryzenforge Enterprises LLP
        </div>
      </div>
    </div>
  );
}
